import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RequestParams, ResponseCatalog } from 'Models'
import { Callback } from 'Src/types/utilTypes'
import { BlockingRuleShortModel, BlockingRulesModel } from 'Pages/orders'

type BlockingRulesState = {
	params: RequestParams
	all: ResponseCatalog<BlockingRulesModel>
	formState: {
		open: boolean
		item?: BlockingRulesModel
	}
}

const initialState: BlockingRulesState = {
	params: new RequestParams(),
	all: new ResponseCatalog<BlockingRulesModel>(),
	formState: {
		open: false,
		item: undefined,
	},
}

export namespace BlockingRulesNS {
	export type GetAll = PayloadAction<{
		params: RequestParams
		clear?: boolean
		callback?: Callback
	}>
	export type SetAll = PayloadAction<ResponseCatalog<BlockingRulesModel>>
	export type SetParams = PayloadAction<RequestParams>
	export type UpdateOne = PayloadAction<{
		data: BlockingRuleShortModel
		id?: number
	}>
	export type CreateOne = PayloadAction<BlockingRuleShortModel>
	export type DeleteOne = PayloadAction<number>
	export type OpenForm = PayloadAction<{ item?: BlockingRulesModel }>
	export type CloseForm = PayloadAction
}

export const blockingRulesSlice = createSlice({
	name: 'blockingRules',
	initialState,
	reducers: {
		getAll: (state, action: BlockingRulesNS.GetAll) => {},
		setAll: (state, action: BlockingRulesNS.SetAll) => {
			state.all = action.payload
		},
		setParams: (state, action: BlockingRulesNS.SetParams) => {
			state.params = action.payload
		},
		updateOne: (state, action: BlockingRulesNS.UpdateOne) => {},
		createOne: (state, action: BlockingRulesNS.CreateOne) => {},
		deleteOne: (state, action: BlockingRulesNS.DeleteOne) => {},
		openForm: (state, action: BlockingRulesNS.OpenForm) => {
			state.formState = {
				open: true,
				item: action.payload.item,
			}
		},
		closeForm: (state, action: BlockingRulesNS.CloseForm) => {
			state.formState = initialState.formState
		},
	},
})
